<template>
    <div>
        <def-field-set :disabled="disabled">
            <tr>
                <td/><td align="center" style="padding-bottom: 10px; font-size: 18px;" v-html="mainTitle">
                </td><td/>
            </tr>

            <template v-for="(opt, index) in defaultOptions">
                <component v-if="checkType(opt.type)"
                           :is="'mod-'+ opt.type"
                           :rules="mutateRules(opt)"
                           :o="o[opt.key]" :n="n[opt.key]" :f.sync="f[opt.key]" :p="p"
                           :params="opt"
                           :full.sync="f">
                </component>
                <mod-maps
                    v-if="showMaps(opt)"
                    :o="o"  :n="n" :f.sync="f"
                    :data="options"
                >
                </mod-maps>
            </template>
            <tr>
                <td></td>
                <td>
                    <div class="mod-compare__condition-fields">
                        <slot/>
                    </div>
                </td>
                <td></td>
            </tr>

        </def-field-set>
      <slot name="duplicates"/>
        <ValidationProvider v-if="competitors" rules="required" v-slot="{ errors }">
            <competitors-field-set
                :competitor-urls-conflicts="competitorUrlsConflicts"
                :competitors="competitors"
                v-on="$listeners"
                :class="{'hasError' : errors[0]}"
                v-tooltip="{content: errors[0], template: tooltipStyle(),}"
            />
            <input type="hidden" v-model="resolvedUrlsConflictModel">
        </ValidationProvider>
        <custom-field-set v-for="(title, block) in blocks" v-if="Object.keys(blockOptions(block)).length>0" :title="title" :key="block" :disabled="disabled">
            <template v-for="(opt, index) in blockOptions(block)">
                <component v-if="checkType(opt.type)"
                           :is="'mod-'+ opt.type"
                           :o="o[opt.key]" :n="n[opt.key]" :f.sync="f[opt.key]"
                           :params="opt"
                           :full.sync="f"/>
            </template>
        </custom-field-set>

      <slot name="links"/>
    </div>
</template>
<script>

import {
    ModImgEdit, ModImg, ModArr, ModText, ModPhone, ModSelect, ModSelectDict, ModPhotos, ModCheckbox,ModHtml, ModSpecialities, ModAssociations, ModEducation, ModEmployment, ModCertificates, ModMaps, ModInfo, ModMetro, ModClinicTypes
} from "./components";
import DefFieldSet from "./fieldsets/Default"
import CustomFieldSet from "./fieldsets/Custom"
import CompetitorsFieldSet from "./fieldsets/Competitors";

export default {
    props: {
        o: {
            type: Object
        },
        n: {
            type: Object
        },
        f: {
            type: Object
        },
        p: {
            type: Object,
            default: () => ({})
        },
        options: {
            type: Array
        },
        blocks: {
            type: Object
        },
        mainTitle: {
            type: String
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        competitors: Array,
        competitorUrlsConflicts: Array,
        resolvedUrlsConflict: String,
    },
    components: {
        CompetitorsFieldSet,
        CustomFieldSet, DefFieldSet, ModImgEdit,
        ModImg, ModArr, ModText, ModPhone, ModSelect,
        ModSelectDict, ModPhotos, ModCheckbox, ModHtml,
        ModSpecialities, ModEducation, ModCertificates, ModEmployment, ModAssociations,
        ModMaps, ModInfo, ModMetro, ModClinicTypes,
    },
    data: function () {
        return {
            types: [
                'arr',
                'img',
                'imgEdit',
                'text',
                'phone',
                'select',
                'selectDict',
                'photos',
                'checkbox',
                'specialities',
                'education',
                'associations',
                'employment',
                'certificates',
                'html',
                'info',
                'metro',
                'clinicTypes',
            ]
        }
    },
    methods:
    {
        mutateRules (opt){
            let rules = opt.rules ?? '';
            if (rules.indexOf('clinicAnyOfSixMod') !== -1){
                if(!(
                    // this.f['proprietary'] === 'private' &&
                    this.f['website'] === '' &&
                    this.f['socialVk'] === '' &&
                    this.f['socialFb'] === '' &&
                    this.f['socialInsta'] === '' &&
                    this.f['socialOk'] === '' &&
                    this.f['socialYoutube'] === '' &&
                    this.f['socialTg'] === '' &&
                    this.f['socialWhatsApp'] === ''
                )){
                    return rules.replace('|clinicAnyOfSixMod','')
                        .replace('clinicAnyOfSixMod','')
                }
            }
            return opt.rules
         },
        blockOptions: function (block) {
            return _.pickBy(this.options,opt => typeof opt.block !== 'undefined' && opt.block === block && block !=='maps');
        },
        checkType: function (type) {
            return this.types.indexOf(type) !== -1;
        },
        showMaps: function (opt) {
            return typeof opt.ymaps !== 'undefined' && opt.ymaps === true;
        },
        tooltipStyle() {
            return `<div class="tooltip" role="tooltip"><div class="tooltip-arrow hasError"></div><div class="tooltip-inner hasError"></div></div>`
        },
    },
    computed: {
        defaultOptions: function () {
            return _.pickBy(this.options,opt => typeof opt.block === 'undefined' || opt.block === 'default');
        },
        resolvedUrlsConflictModel: { get() { return this.resolvedUrlsConflict } }
    },
}
</script>

<style lang="scss">
    .mod-compare {
        &__condition-fields {
            display: flex;
            flex-direction: column;
            width: 100%;
        }
    }

     td.selected .multiselect__tags, td.selected .multiselect__single {
       background-color: rgba(255, 255, 255, 0.1) !important;
     }

</style>
